import axios from 'axios';
import constants from '../constants/constants';

export const configureAxios = () => {
    axios.defaults.timeout = constants.AXIOS_TIMEOUT;
    const url = `/api/authentication/login?callback=${process.env.PUBLIC_URL}`;
    axios.interceptors.response.use(
        (response) => {
            const imageRequest = response?.request?.responseURL.startsWith(`${window.location.origin}/webfiles`);
            if (!imageRequest && response.status === 401) {
                window.location.replace(url);
            }
            if (!response.data) {
                response.data = { status: 200 };
            }
            return response;
        },
        (error) => {
            const imageRequest = error?.request?.responseURL.startsWith(`${window.location.origin}/webfiles`);
            if (error?.response?.status === 401) {
                if (!imageRequest && !error?.response?.config.url.includes('/api/osint/users')) {
                    window.location.replace(url);
                }
            }
            if (!error.data) {
                error.data = { status: 404 };
            }
            return Promise.reject(error);
        },
    );
};
